import { gql, useQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedEntranceTicketTypeBackOffice } from 'apollo/localizedTypes';

const LIST_ENTRANCE_TICKET_TYPES_BACKOFFICE = gql`
  query listEntranceTicketTypesBackOffice {
    listEntranceTicketTypesBackOffice {
      adultValue
      description {
        ...LocalizedTextFields
      }
      id
      maxStock
      name {
        ...LocalizedTextFields
      }
      otherValue
      status
      isBicycle
      visibility
      features {
        ticketFeatureId
        slug
        name {
          ...LocalizedTextFields
        }
        status
        availability
        position
        note {
          ...LocalizedTextFields
        }
      }
      entranceImages {
        id
        image
        uploadUrl
      }
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useListEntranceTicketTypesQuery = () => {
  return useQuery<{
    listEntranceTicketTypesBackOffice: LocalizedEntranceTicketTypeBackOffice[];
  }>(LIST_ENTRANCE_TICKET_TYPES_BACKOFFICE, {});
};
export default useListEntranceTicketTypesQuery;
